module.exports = __webpack_public_path__ + "img/btn_label.4db57985.svg";